import React from 'react';
import { connect } from 'react-redux';
import { noop } from 'lodash';
import moment from 'moment';

import beUpdateAppointment from 'actions/appointment/beUpdateAppointment.action';
import { beFindReaderV1 } from 'actions/pos/beFindReader.action';
import { feSidebarAppointmentClear } from 'actions/ui.actions';
import closeIco from 'assets/images/close-btn-violet.svg';
import IcoCalendar from 'assets/images/show-hide-cal-icon.svg';
import addserviceIco from 'assets/images/xAddserviceicon.svg';
import ToggleFeature from 'components/core/ToggleFeature.component';
import SalonModal from 'components/dialog/SalonModal.component';
import Button from 'components/form/Button.component';
import DatePickerInput from 'components/form/DatePickerInput.component';
import Icon from 'components/generic/Icon.component';
import IconStatus from 'components/generic/IconStatus.component';
import withSalonCurrency from 'components/hoc/withSalonCurrency.hoc';
import { CURRENCY_ACTIVE_ICONS } from 'constants/currency.const';
import LINK from 'constants/link.const';
import { useAppointmentPermissions } from 'hooks/useAppointmentPermissions.hook';
import { withTranslation } from 'providers/GILT.provider';
import { selectCurrentSalonCountryCode, selectCurrentSalonId, selectCurrentSalonServices, selectCurrentSalonStylists } from 'selectors/currentSalon.selectors';
import { selectBookingClientTags } from 'selectors/simple';
import asArray from 'utils/arrays/asArray.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import fromAnyToInteger from 'utils/converters/fromAnyToInteger';
import fromAnyToString from 'utils/converters/fromAnyToString';
import fromObjectToQueryString from 'utils/converters/object/fromObjectToQueryString.util';
import fromPropsToRouting from 'utils/converters/props/fromPropsToRouting.util';
import { fromPropsToIsWeek, fromPropsToPathSegments, fromPropsToQuery } from 'utils/converters/props/path.util';
import mapActionsToDispatchToProps from 'utils/core/mapActionsToDispatchToProps.util';
import { formatSegmentDay, formatSegmentWeek } from 'utils/date/format.util';
import toggleBlock from 'utils/dom/toggleBlock.util';
import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';
import currencySign from 'utils/intl/currencySign.util';
import linkTo from 'utils/links/linkTo.util';
import navFor from 'utils/links/navFor.util';
import logger from 'utils/logger.util';
import asObject from 'utils/objects/asObject.util';
import deRef from 'utils/objects/deRef.util';
import parsePath from 'utils/parsers/parsePath.util';
import isNotFn from 'utils/predicates/function/isNotFn.util';
import editPathSegments from 'utils/values/editPathSegments.util';

import {
  appointmentAndDepositThunk,
  appointmentAndRepeatThunk,
  cleanBookingData,
  createAppointmentWithProcedures,
  getPreferenceList,
  hasHighNoShowRate,
  removeService,
  setIsEditBooking,
  updateAppointmentAndDepositThunk,
  updateAppointmentAndRepeatThunk,
  updateAppointmentWithProcedures,
  updateService,
} from 'booking/actions';
import BookingSummary from 'booking/components/BookingSummary';
import BackButton from 'booking/components/common/bw-header/BackButton';
import HeaderWrapper from 'booking/components/common/bw-header/HeaderWrapper';
import BWContent from 'booking/components/common/BWContent';
import BookingNotes from 'booking/components/common/client/BookingNotes';
import { BWClientHeader } from 'booking/components/common/client/BWClientHeader';
import DropdownService from 'booking/components/common/DropdownService';
import FrequentlyBtnComponent from 'booking/components/common/FrequentlyBtnComponent';
import FrequentlyButtonButton from 'booking/components/common/FrequentlyButton';
import TextField from 'booking/components/common/TextField';
import { setCurrentDay } from 'scheduler/actions';
import { trackEvent } from 'tracking/actions';

import CN from './EditBooking.module.scss';

const CTAG = 'EditBooking';
const L = logger(CTAG);

class EditBooking extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      category: false,
      changedPref: [],
      datePickerOpen: false,
      dayView: true,
      depositTaken: null,
      isSearching: false,
      modalClose: false,
      removedService: false,
      serviceId: 0,
      showModal: false,
      hoverPastDay: false,
    };
    this.bookingSummaryRef = React.createRef();
  }

  componentDidMount() {
    const { addedServices, client, clientId, getPreferenceList, hasHighNoShowRate, salonId, setIsEditBooking } = this.props;

    if (clientId && salonId) {
      hasHighNoShowRate(clientId, salonId);
      getPreferenceList(salonId, client.id);
      setIsEditBooking(true);
    }

    if (addedServices.length === 0) {
      const [, , , , dateString, stylistId, , idFromDay, idFromWeek] = fromPropsToPathSegments(this.props) ?? [];
      const isWeek = fromPropsToIsWeek(this.props);

      navFor(CTAG, 'componentDidMount()', this.props).push({
        pathname: linkTo({
          pattern: isWeek ? LINK.bookingWeekLoad : LINK.bookingDayLoad,
          params: {
            salonId,
            appointmentId: fromAnyToInteger(isWeek ? idFromWeek : idFromDay),
            dateString: isWeek ? formatSegmentWeek(dateString) : formatSegmentDay(dateString),
            stylistId,
          },
        }),
      });
    }

    if (this.props?.location?.state?.openCalendar) this.openDatePicker();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { client, clientDepositData, depositTaken, fetchAppointment, preferenceList, salonId, saved, currentSalonAbbr, currentSalonSign } = this.props;

    if (client && !depositTaken && fromAnyToBool(clientDepositData.response)) {
      const clientId = client.id;
      this.getDepositDetails(clientId, clientDepositData, salonId, fetchAppointment, currentSalonAbbr, currentSalonSign);
    }

    if (nextProps.saved && !saved) {
      this.close();
    }

    if (nextProps.addedServices.length > 0 && moment(nextProps.addedServices[0].start_time).get('hour') !== 0 && nextProps.addedServices.filter((s) => s.deleted === true).length > 0) {
      setTimeout(() => this.setState({ removedService: true }), 3000);
    }

    if (preferenceList.length > 0) {
      const countAdded = nextProps.addedServices.length;
      if (countAdded > 0) {
        const newlyAddedService = nextProps.addedServices.filter((d) => d.deleted !== true)[countAdded - 1];
        if (newlyAddedService) {
          const prefExists = preferenceList.filter((c) => c.service === newlyAddedService.service_id);
          if (prefExists.length > 0) {
            if (newlyAddedService.stylist_id !== prefExists[0].stylist) {
              const { changedPref } = this.state;
              const newChangedPref = [prefExists[0].stylist, newlyAddedService.stylist_id];
              if (changedPref.length === 0 || (changedPref.findIndex((p) => p.toString() === newChangedPref.toString()) < 0 && newChangedPref.indexOf(prefExists[0].stylist) < 0)) {
                changedPref.push(newChangedPref);
                this.setState({ showModal: true, serviceId: newlyAddedService.local_id, changedPref });
              }
            }
          }
        }
      }
    }
  }

  componentWillUnmount() {
    this.props.setIsEditBooking(false);
  }

  getDepositDetails = (clientId, clientDepositData, salonId, fetchAppointment, currentSalonAbbr, currentSalonSign) => {
    if (clientId && salonId) {
      if (clientDepositData && clientDepositData.isFetching) {
        return this.props.t('scheduler.editBooking.loadingDepositData');
      }
      if (clientDepositData && clientDepositData.errorMessage) {
        return clientDepositData.errorMessage;
      }
      if (clientDepositData && clientDepositData.response && clientDepositData.response.deposits_list) {
        const bookingApptId = fetchAppointment && fetchAppointment.response && fetchAppointment.response.id ? fetchAppointment.response.id : -1;

        const clientDeposits = clientDepositData.response.deposits_list;
        if (clientDeposits.filter((deposit) => deposit.created_for_appointmentId === bookingApptId).length <= 0) {
          return false;
        }

        const depositTaken = clientDeposits.filter((d) => d.created_for_appointmentId === bookingApptId)[0].amount;
        if (!this.state.depositTaken) {
          this.setState({ depositTaken });
        }

        return this.props.t('scheduler.editBooking.depositTaken', {
          depositAmount: currencySign({ value: depositTaken, currentSalonAbbr, currentSalonSign }),
        });
      }
      return false;
    }
    return false;
  };

  // FIXME: seems unused, remove if that is true
  setSearching = (isSearching) => void this.setState({ isSearching });

  setBookingDate = (date) => {
    const { addedServices, permIsMoveBlocked, setCurrentDay, trackEvent, updateService } = this.props;
    const { datePickerOpen } = this.state;

    if (permIsMoveBlocked) {
      L.warn('setBookingDate()', 'blocked: can_move_appointment=no_access');
      return;
    }

    setCurrentDay(date.startOf('day'));

    trackEvent('ResheduleInBookingWindow');

    this.setState({ datePickerOpen: !datePickerOpen });

    if (addedServices && addedServices.length > 0) {
      const newAddedServices = addedServices.slice();

      for (let i = 0; i < addedServices.length; i += 1) {
        const newStartTime = moment(newAddedServices[i].start_time);

        newStartTime.set({
          year: moment(date).get('year'),
          month: moment(date).get('month'),
          date: moment(date).get('date'),
          hour: newStartTime.get('hour'),
          minute: newStartTime.get('minute'),
          second: newStartTime.get('second'),
          millisecond: 0,
        });

        newAddedServices[i].start_time = moment(newStartTime).toISOString();

        updateService(newAddedServices[i]);
      }
    }
  };

  setOneOrAll = (oneOrAll) => {
    // FIXME: parent component depends on concrete child method
    // NOTE: breaks D from SOLID: Depend on abstractions, not on concretions
    const { saveBooking } = asObject(deRef(this.bookingSummaryRef));
    const { isRepeatBooking } = this.props;

    if (isNotFn(saveBooking)) {
      return void L.error('setOneOrAll()', 'Not a function saveBooking:', saveBooking, this.bookingSummaryRef);
    }

    if (!isRepeatBooking) {
      return void saveBooking();
    }

    if (oneOrAll === 'one' || oneOrAll === 'all') {
      return void saveBooking(oneOrAll);
    }

    const info = { oneOrAll, isRepeatBooking, saveBooking, 'this.bookingSummaryRef': this.bookingSummaryRef };
    return void L.warn('setOneOrAll()', 'Undefined behavior', info);
  };

  openDatePicker = () => {
    if (this.props.permIsMoveBlocked) {
      L.warn('openDatePicker()', 'blocked: can_move_appointment=no_access');
      return;
    }
    this.props.trackEvent('edit_datebar');
    this.setState({ datePickerOpen: !this.state.datePickerOpen });
  };

  showNoShowData = (hasHighNoShowRate) => {
    const { t } = this.props;

    if (hasHighNoShowRate.isFetching) {
      return <span>{t('scheduler.editBooking.loadingNoShowData')}</span>;
    } else if (!hasHighNoShowRate.isFetching && !hasHighNoShowRate.errorMessage) {
      if (hasHighNoShowRate.no_shows && hasHighNoShowRate.no_shows > 2) {
        return (
          <div
            className="text-center no-show-deposit-prompt"
            style={{
              color: 'rgb(211, 47, 47)',
              fontSize: '12px',
              display: 'block',
              fontWeight: '600',
            }}
          >
            <span className="deposit-promt-line-1">
              {this.props.client.user_name} {t('scheduler.editBooking.noShowRateWarningMsg.part1')} <br />
            </span>
            <span className="deposit-promt-line-2">
              {t('scheduler.editBooking.noShowRateWarningMsg.part2', { noShowRate: hasHighNoShowRate.no_shows })}
              <br />
            </span>
            <span className="deposit-promt-line-3">
              {hasHighNoShowRate.appointments} {t('scheduler.editBooking.noShowRateWarningMsg.part3')} <br />
            </span>
            <span className="deposit-promt-line-4">
              {t('scheduler.editBooking.noShowRateWarningMsg.part4')} <br />
            </span>
            <br />
            <br />
          </div>
        );
      }
      return <span className="no-show-deposit-prompt" />;
    }
  };

  goToClientProfile = () => {
    const { clientId, location } = this.props;

    if (clientId) {
      navFor(CTAG, 'goToClientProfile()', this.props).push({
        pathname: `${fromPropsToPathSegments(this.props)
          .filter((str) => str !== 'summary')
          .join('/')}/client/${clientId.toString()}`,
        state: { from: location.pathname }, // Pass current path so we can navigate back to it
      });
    }
  };

  goToEditClientProfile = () => {
    const { clientId, location } = this.props;

    if (clientId) {
      if (location.pathname.indexOf('/summary')) {
        navFor(CTAG, 'goToEditClientProfile()', this.props).push({
          pathname: `${fromPropsToPathSegments(this.props)
            .slice(0, -1) // remove last elm from array 'summary'
            .join('/')}/client/edit/${clientId.toString()}`,
        });
      }
    }
  };

  goToPatchView = () => {
    const { location } = this.props;

    if (location.pathname.indexOf('/summary')) {
      const { clientId, trackEvent } = this.props;

      if (clientId) {
        trackEvent('goto_patch_view');

        navFor(CTAG, 'goToPatchView()', this.props).push({
          pathname: `${fromPropsToPathSegments(this.props)
            .slice(0, -1) // remove last elm from array 'summary'
            .join('/')}/client/${clientId.toString()}`,
          state: { fromNoPatch: true },
        });
      }
    }
  };

  goBackToServiceList = () => {
    this.setState({ category: undefined });
  };

  goToFrequentlyList = () => {
    navFor(CTAG, 'goToFrequentlyList()', this.props).push({
      pathname: `${fromPropsToPathSegments(this.props)
        .filter((str) => str !== 'summary')
        .join('/')}/frequently-booked`,
    });
  };

  close = () => {
    const { cleanBookingData } = this.props;
    const { dayView } = this.state;

    cleanBookingData();

    navFor(CTAG, 'close()', this.props).push({
      pathname: `${editPathSegments((segments) => {
        if (!dayView) {
          return segments.slice(0, 6);
        }
        return segments.slice(0, 5);
      }, this.props)}`,
    });
  };

  goToAddService = () => {
    if (this.props.isSlideoutServicesBlocked) {
      return;
    }

    navFor(CTAG, 'goToAddService()', this.props).push({
      pathname: `${fromPropsToPathSegments(this.props)
        .filter((s) => s !== 'summary')
        .filter((s) => s !== 'services')
        .join('/')}/addanotherservice`,
      search: fromObjectToQueryString({ ...fromPropsToQuery(this.props), addAnotherService: true }),
    });
  };

  takeDeposit = () => {
    const { deposit } = this.props;
    const { depositTaken } = this.state;

    if (deposit || depositTaken) {
      return;
    }

    const pathname = `${fromPropsToPathSegments(this.props)
      .filter((s) => s !== 'summary')
      .filter((s) => s !== 'services')
      .join('/')}/deposit`;

    navFor(CTAG, 'takeDeposit()', this.props).push({ pathname });
  };

  saveBooking = (oneOrAll = '') => {
    const bookingSummary = deRef(this.bookingSummaryRef).current;
    const saveBooking = typeof bookingSummary.saveBooking === 'function' ? bookingSummary.saveBooking : noop;

    if (bookingSummary && (oneOrAll === 'one' || oneOrAll === 'all')) {
      saveBooking(oneOrAll);
    }
  };

  showCloseModal = (modalClose) => void this.setState({ modalClose }); // TODO: seems unused, check and if so, remove it
  viewCalendar = () => void toggleBlock(document.querySelector('.show-hide-booking'));

  handleMouseOver = (e) => {
    if (e.target.closest('.react-datepicker__day.is-past-day')) {
      this.setState({ hoverPastDay: true });
    }
  };

  handleMouseOut = (e) => {
    if (e.target.closest('.react-datepicker__day.is-past-day')) {
      this.setState({ hoverPastDay: false });
    }
  };

  render() {
    const {
      addedServices,
      appointmentAndDepositThunk,
      appointmentAndRepeatThunk,
      beFindReader,
      beUpdateAppointment,
      appointmentDetails,
      bookingNotes,
      cleanBookingData,
      client,
      clientId,
      clientNoShowData,
      clientTags,
      createAppointmentWithProcedures,
      currentDay,
      deposit,
      depositTaken,
      frequency,
      frequencyType,
      history,
      isEditBooking,
      isRepeatBooking,
      location,
      match,
      removeService,
      salonId,
      stylistList,
      isFetching,
      isFetchingService,
      until,
      updateAppointmentAndDepositThunk,
      updateAppointmentAndRepeatThunk,
      updateAppointmentWithProcedures,
      currentSalonAbbr,
      currentSalonSign,
      countryCode,
      permIsMoveBlocked,
      isSlideoutServicesBlocked,
      t,
    } = this.props;

    const { category, datePickerOpen, isSearching, modalClose, removedService, serviceId, showModal, hoverPastDay } = this.state;

    const displayDeposit = depositTaken || this.state.depositTaken;

    let selectedDate;

    if (!selectedDate && addedServices.length > 0) {
      selectedDate = moment(addedServices[0].start_time);
    }

    if (!selectedDate) {
      selectedDate = currentDay;
    }

    // rebook from checkout
    if (match.path.indexOf('appointment/edit/-1000') > 0 && addedServices.length) {
      selectedDate = moment(addedServices[0].start_time);
    }

    const depositAmount = currencySign({ value: displayDeposit, currentSalonAbbr, currentSalonSign });
    const depositBtnClass = !displayDeposit ? 'more-option-item' : 'more-option-item disabled';
    const depositBtnText =
      // eslint-disable-next-line no-nested-ternary
      typeof displayDeposit === 'number' ? t('scheduler.editBooking.depositTaken', { depositAmount }) : typeof displayDeposit === 'string' ? displayDeposit : t('scheduler.editBooking.takeDeposit');

    const repeatBtnText = isRepeatBooking
      ? t('scheduler.editBooking.repeatEveryWeek', {
          frequency,
          date: moment(until).format('Do MMM YYYY'),
        })
      : '';

    const reduced = addedServices.reduce((agg, curr) => (!curr.deleted && moment(curr.start_time).isBefore(moment(agg.start_time)) ? curr : agg), addedServices[0]);

    const dateBtnClass = datePickerOpen ? 'date-button' : 'date-button-closed';
    const editBtnName = datePickerOpen ? t('common.buttons.doneUpp') : t('scheduler.editBooking.changeDateButton');

    const depositIco = CURRENCY_ACTIVE_ICONS[countryCode];

    const appointmentDate = moment(reduced ? reduced.start_time : moment());

    return (
      <div data-bem="EditBooking">
        <span data-bem="EditBooking__title" className="view-hide-booking-window" onClick={this.viewCalendar} role="button" tabIndex={0}>
          <img src={IcoCalendar} alt="" />
        </span>
        <div data-bem="EditBooking__booking-window" className="BookingWindow show-hide-booking e">
          <SalonModal tag="EditBooking__modal--warning" isOpen={showModal} withFooter>
            <SalonModal.Body>
              <div className={CN.modalContent}>
                <IconStatus variant="alert">
                  <Icon variant="alert" />
                </IconStatus>
                <div className={CN.modalTitle}>{t('scheduler.editBooking.alertModal.title')}</div>
                <span className={CN.modalText}>{t('scheduler.editBooking.alertModal.description')}</span>
              </div>
            </SalonModal.Body>
            <SalonModal.Footer>
              <div className={CN.modalButtons}>
                <Button
                  variant="outlineForce"
                  onClick={() => {
                    this.setState({ showModal: false });
                    removeService(serviceId, true);
                  }}
                  xSpace
                >
                  {t('scheduler.cancelExit')}
                </Button>
                <Button variant="primaryForce" onClick={() => void this.setState({ showModal: false })} xSpace>
                  {t('scheduler.editBooking.alertModal.confirmButton')}
                </Button>
              </div>
            </SalonModal.Footer>
          </SalonModal>

          <section data-bem="EditBooking__service-selection" className="service-selection" id="edit-booking-sticky-header">
            <HeaderWrapper>
              {category && <BackButton onClick={this.goBackToServiceList} />}
              <div role="button" tabIndex={0} onClick={() => void this.setState({ modalClose: true })} className="close-ico">
                <img src={closeIco} alt="" />
              </div>
            </HeaderWrapper>

            <BWContent additionalClass="space">
              {/* eslint-disable-next-line no-nested-ternary */}
              {client !== null && client !== undefined ? (
                client.status !== 'deleted' ? (
                  <BWClientHeader
                    client={client}
                    clientTags={clientTags}
                    goToClientProfile={this.goToClientProfile}
                    goToEditClientProfile={this.goToEditClientProfile}
                    goToPatchView={this.goToPatchView}
                    noShow={this.showNoShowData(clientNoShowData)}
                    salonId={salonId}
                  />
                ) : (
                  <div>{t('scheduler.editBooking.deletedClient')}</div>
                )
              ) : (
                <span style={{ display: 'block', paddingBottom: '20px', fontFamily: 'ProximaNova-sb' }}>{t('scheduler.editBooking.walkIn')}</span>
              )}

              {!isSearching && (
                <ToggleFeature flag="bookingInlineDatePicker">
                  <TextField htmlFor="bookingDayPicker" labelName="">
                    <div data-bem="EditBooking__date-picker" data-perm-move-blocked={String(Boolean(permIsMoveBlocked))} className="co-date-picker mt-n10 font-ProximaNova-sb" id="bookingDayPicker">
                      <div className="co-date-picker mt-n10" id="bookingDayPicker" onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut}>
                        <div className={dateBtnClass} onClick={this.openDatePicker} role="button" tabIndex={-1}>
                          <p className="font-ProximaNova-sb"> {moment(selectedDate).format('ddd ll')}</p>

                          {!permIsMoveBlocked && <button className="edit-btn font-ProximaNova-sb">{editBtnName}</button>}
                        </div>
                        {datePickerOpen && !permIsMoveBlocked && (
                          <DatePickerInput
                            tag="EditBooking__appointment-date"
                            component={DatePickerInput.CommonDatePicker}
                            className="closed"
                            inline
                            selected={appointmentDate}
                            locale="en-GB"
                            onOutsideClick={alwaysNoop}
                            onChange={this.setBookingDate}
                            dayClassName={(date) => moment(date).isBefore(moment(), 'day') && 'is-past-day'}
                          >
                            <div className={CN.pastDateTooltip} style={{ display: hoverPastDay ? 'block' : 'none' }}>
                              {t('scheduler.editBooking.dateInPastMsg')}
                            </div>
                          </DatePickerInput>
                        )}
                        {datePickerOpen && !permIsMoveBlocked && addedServices.length && (
                          <DatePickerInput
                            data-bem="EditBooking__start-time"
                            component={DatePickerInput.WeeksComponent}
                            onChangeDate={this.setBookingDate}
                            selectedDate={moment(addedServices[0].start_time)}
                          />
                        )}
                      </div>
                    </div>
                  </TextField>
                </ToggleFeature>
              )}

              {!isSearching &&
                addedServices &&
                asArray(addedServices).map(
                  (item, index) =>
                    !item.deleted && (
                      <DropdownService
                        tag="EditBooking"
                        key={item.id}
                        backgroundColor={item.service.category.color}
                        borderColor={item.service.category.color}
                        index={index}
                        isEditFlow
                        removedService={removedService}
                        service={item} // hardcoded
                        stylistList={stylistList}
                        textColor="white"
                      />
                    ),
                )}

              <div data-bem="EditBooking__more-options" className="more-options-menu">
                {!isSlideoutServicesBlocked && (
                  <button type="button" data-bem="EditBooking__add-service-button" className="more-option-item" key="add-service" tabIndex="0" onClick={this.goToAddService}>
                    <img src={addserviceIco} alt="Add service" className="icon ico-booking-options" />
                    <div>{t('scheduler.editBooking.addServiceButton')}</div>
                  </button>
                )}

                {client && !isRepeatBooking && !displayDeposit && (
                  <button data-bem="EditBooking__take-deposit-button" className={depositBtnClass} key="take-deposit" tabIndex="0" onClick={this.takeDeposit}>
                    <img src={depositIco} alt="Take deposist" className="icon ico-booking-options" />
                    <div>{t('scheduler.editBooking.takeDepositButton')}</div>
                  </button>
                )}

                {!isSearching && client && !client.has_no_appointments && (displayDeposit || isRepeatBooking) && <FrequentlyButtonButton onClickFrequentBtn={this.goToFrequentlyList} />}
              </div>

              {isRepeatBooking && (
                <div data-bem="EditBooking__is-repeat-booking" className="deposit-taken">
                  <div>{repeatBtnText}</div>
                </div>
              )}

              {displayDeposit && (
                <div data-bem="EditBooking__has-deposit-taken" className="deposit-taken">
                  <div>{depositBtnText}</div>
                </div>
              )}

              {!displayDeposit && !isSearching && client && !client.has_no_appointments && !isRepeatBooking && <FrequentlyBtnComponent onClickFrequentBtn={this.goToFrequentlyList} />}

              {!isSearching && (
                <TextField htmlFor="bookingnotes" labelName={t('scheduler.noteLog.editLabel')}>
                  <BookingNotes notes={bookingNotes} />
                </TextField>
              )}
            </BWContent>

            {!isSearching && addedServices && addedServices.length > 0 && (
              <BookingSummary
                addedServices={addedServices}
                appointmentDetails={appointmentDetails}
                appointmentAndDepositThunk={appointmentAndDepositThunk}
                appointmentAndRepeatThunk={appointmentAndRepeatThunk}
                beFindReader={beFindReader}
                beUpdateAppointment={beUpdateAppointment}
                bookingNotes={bookingNotes}
                cleanBookingData={cleanBookingData}
                clientId={clientId}
                createAppointmentWithProcedures={createAppointmentWithProcedures}
                deposit={deposit}
                frequency={frequency}
                frequencyType={frequencyType}
                history={history}
                isEditBooking={isEditBooking}
                isFetching={isFetching}
                isFetchingService={isFetchingService}
                isRepeatBooking={isRepeatBooking}
                location={location}
                match={match}
                ref={this.bookingSummaryRef}
                salonId={salonId}
                setOneOrAll={this.setOneOrAll}
                until={until}
                updateAppointmentAndDepositThunk={updateAppointmentAndDepositThunk}
                updateAppointmentAndRepeatThunk={updateAppointmentAndRepeatThunk}
                updateAppointmentWithProcedures={updateAppointmentWithProcedures}
                feSidebarAppointmentClear={this.props.feSidebarAppointmentClear}
              />
            )}
          </section>
        </div>

        <SalonModal tag="EditBooking__modal--edit--close" isOpen={modalClose} withFooter>
          <SalonModal.Body>
            <IconStatus variant="alert">
              <Icon variant="alert" />
            </IconStatus>
            <div className={CN.modalContent}>
              <div className={CN.modalTitle}>{t('scheduler.exitTitle')}</div>
              <span className={CN.modalText}>{t('scheduler.exitDescription')}</span>
            </div>
          </SalonModal.Body>
          <SalonModal.Footer>
            <div className={CN.modalButtons}>
              <Button variant="outlineForce" onClick={() => void this.setState({ modalClose: false })} xSpace>
                {t('scheduler.cancelExit')}
              </Button>
              <Button
                xSpace
                variant="primaryForce"
                onClick={() => {
                  cleanBookingData();

                  try {
                    // parse the current browser location for the useful info
                    const [, salonId, view, dateString, maybeStylistId] = parsePath({
                      pattern: `${LINK.schedule}/*`,
                      path: fromPropsToRouting(this.props).url,
                    });

                    // due to this being optional, only set it up for week view
                    const stylistId = view === 'week' ? maybeStylistId : void 1;

                    // instead of going back with indices, just push forward to the schedule landing page
                    navFor(CTAG, 'render()', 'onRight()', this.props).push(linkTo({ pattern: LINK.schedule, params: { salonId, view, dateString, stylistId } }));
                  } catch (e) {
                    L.warn('render()', 'onRight()', e);
                  }
                }}
              >
                {t('scheduler.confirmExit')}
              </Button>
            </div>
          </SalonModal.Footer>
        </SalonModal>
      </div>
    );
  }
}

const EditBookingConnected = connect(
  (state) => ({
    addedServices: state.booking.addedServices,
    appointmentDetails: state.scheduler.appointmentDetails,
    bookingNotes: state.booking.notes,
    client: state.booking.client,
    clientDepositData: state.booking.clientDepositData,
    clientId: state.booking.client ? state.booking.client.id : null,
    clientNoShowData: state.booking.clientNoShowData,
    clientTags: selectBookingClientTags(state),
    countryCode: selectCurrentSalonCountryCode(state),
    currentDay: state.scheduler.currentDay,
    deposit: state.booking.deposit,
    depositTaken: state.booking.deposit ? state.booking.deposit.amount : null,
    fetchAppointment: state.booking.fetchAppointment,
    frequency: state.booking.frequency,
    frequencyType: state.booking.frequencyType,
    isEditBooking: state.booking.isEditBooking,
    isRepeatBooking: state.booking.isRepeatBooking,
    preferenceList: state.booking.preferenceList,
    salonId: selectCurrentSalonId(state),
    saved: state.booking.saved,
    services: selectCurrentSalonServices(state),
    stylistList: selectCurrentSalonStylists(state),
    until: state.booking.until,
  }),
  mapActionsToDispatchToProps({
    appointmentAndDepositThunk,
    appointmentAndRepeatThunk,
    beFindReader: beFindReaderV1,
    beUpdateAppointment,
    createAppointmentWithProcedures,
    cleanBookingData,
    getPreferenceList,
    hasHighNoShowRate,
    removeService,
    setCurrentDay,
    setIsEditBooking,
    trackEvent,
    updateAppointmentAndDepositThunk,
    updateAppointmentAndRepeatThunk,
    updateAppointmentWithProcedures,
    updateService,
    feSidebarAppointmentClear,
  }),
)(withTranslation()(withSalonCurrency(EditBooking)));

const appointmentHasOwnService = (addedServices, accessStylistId) =>
  asArray(addedServices).some((service) => !service?.deleted && fromAnyToString(service?.stylist_id) === fromAnyToString(accessStylistId));

const EditBookingHoc = (props) => {
  const { isMoveBlocked, isSlideoutBlocked, isSlideoutPersonalOnly, accessStylistId } = useAppointmentPermissions();
  const hasOwnService = appointmentHasOwnService(props.addedServices, accessStylistId);
  const isSlideoutServicesBlocked = isSlideoutBlocked || (isSlideoutPersonalOnly && !hasOwnService);
  return <EditBookingConnected {...props} permIsMoveBlocked={isMoveBlocked} isSlideoutServicesBlocked={isSlideoutServicesBlocked} />;
};

export default EditBookingHoc;
